<template lang="html">
  <div class="column is-10" v-if="publications">
    <div class="has-text-centered p-7 is-size-3 has-text-gray is-italic">
      Coming soon ~
    </div>
    <!-- <news-element v-for="publication in publications" :key="publication.id" :publication="publication"/> -->
  </div>
</template>

<script>
// import NewsElement from './NewsElement.vue'
export default {
  props: ['category'],
  data () {
    return {
      publications: []
    }
  },
  components: {
    // NewsElement
  },
  created () {
    this.fetchPublications()
  },
  methods: {
    fetchPublications () {
      this.$store
        .dispatch('search/publications/create', { category: this.category })
        .then((resp) => {
          this.publications = resp.data.data
        })
        .catch((error) => {
          console.log('Errors')
          console.log(error.response)
        })
    }
  }
}
</script>

<style lang="css" scoped></style>
